module.exports = __webpack_public_path__ + "static/rock-solid-borders-white-logo-e8f42e662a7ecca6f4499116cf7dfe00.svg";